import {
    Collapse,
    createStyles,
    Grid,
    IconButton,
    ListItem,
    ListItemSecondaryAction,
    Typography,
    WithStyles,
    withStyles,
} from '@material-ui/core';
import { ExpandLess, ExpandMore, RemoveCircle } from '@material-ui/icons';
import { inject } from 'mobx-react';
import React from 'react';
import { BehaviorDto } from 'src/generated_client';
import { IStores } from 'src/Stores';
import ObservationsStore from 'src/stores/ObservationsStore';
import ObservationEditor from './observations/ObservationEditor';
import Observations from './observations/ObservationList';

const styles = createStyles({
    observations: {
        border: '1px',
        borderColor: '#eeeeee',
        borderRadius: '4px',
        borderStyle: 'solid',
        marginLeft: '40%',
        width: '60%',
    },
    occurredButton: {
        marginRight: '25px',
    },
});

interface IBehaviorEditorProps extends WithStyles<typeof styles> {
    assessmentId?: string;
    behavior: BehaviorDto;
    removeBehavior: (behaviorId: string) => void;
    getObservationStoreForBehavior?: (behaviorId: string) => ObservationsStore;
}
class BehaviorEditor extends React.Component<IBehaviorEditorProps> {
    public state = {
        open: false,
    };

    public handleClick = (open: boolean) => (event: React.MouseEvent) => {
        open = !open;
        this.setState({ open });
        event.stopPropagation();
    };

    public callRemoveBehavior = (behaviorId: string) => (event: React.MouseEvent) => {
        this.props.removeBehavior(behaviorId);
        event.stopPropagation();
    };

    public updateObservationTable = (behaviorId: string) => {
        const observationStore = this.props.getObservationStoreForBehavior!(behaviorId);
        observationStore.dataTableStore.loadData();
    };

    public render() {
        const { assessmentId, behavior } = this.props;
        const observationStore = this.props.getObservationStoreForBehavior!(behavior.id!);
        return (
            <>
                <ListItem
                    disableGutters={true}
                    disableRipple
                    button
                    onClick={this.handleClick(this.state.open)}
                >
                    <ListItem>
                        {this.state.open ? <ExpandLess /> : <ExpandMore />}
                        <Typography color="primary" variant="subtitle1" inline>
                            {String.fromCharCode(96 + behavior.displayOrder!)}.&nbsp;
                        </Typography>
                        <Typography>{behavior.name}</Typography>
                    </ListItem>
                    <ListItemSecondaryAction>
                        <IconButton
                            aria-label="Delete"
                            color="secondary"
                            onClick={this.callRemoveBehavior(behavior.id!)}
                        >
                            <RemoveCircle />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                    <Grid container spacing={32}>
                        <Grid item xs={4}>
                            <ObservationEditor
                                behaviorId={behavior.id}
                                assessmentId={assessmentId}
                                updateObservationTable={this.updateObservationTable}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <Observations
                                dataTableManager={observationStore.dataTableStore}
                                getColumnSettingsAndObservations={
                                    observationStore.getColumnSettingsAndObservations
                                }
                            />
                        </Grid>
                    </Grid>
                </Collapse>
            </>
        );
    }
}

const InjectedBehaviors = inject<IStores, IBehaviorEditorProps, Partial<IBehaviorEditorProps>, any>(
    (stores: IStores) => ({
        getObservationStoreForBehavior: stores.chevrons.getObservationStoreForBehavior,
    })
)(withStyles(styles)(BehaviorEditor));

export default InjectedBehaviors;



// WEBPACK FOOTER //
// ./src/chevrons/behaviors/BehaviorEditor.tsx